var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-summary"},[_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(" "+_vm._s(_vm.label)+": "),_c('strong',{staticClass:"text-dark"},[_vm._v(_vm._s(_vm.formatNumber(_vm.total)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }